import Message, { MessageReplyTo } from "types/Message";

/** Tailwind classes for message bubble surfaces (chat area uses stone-50 background). */
export function getMessageBubbleClassName(type: Message["type"]): string {
  switch (type) {
    case "user":
      return "bg-emerald-50 border border-emerald-200/80 text-gray-900";
    case "assistant":
      return "bg-white border border-primary/20 shadow-sm text-gray-900";
    case "operator":
      return "bg-white border border-sky-200/80 shadow-sm text-gray-900";
    case "manager-response":
      return "bg-stone-100 border border-stone-300/80 text-stone-700 italic";
    case "manager":
      return "bg-stone-200/90 border border-stone-300 text-stone-700 italic";
    case "deferred":
      return "bg-amber-50/80 border border-dashed border-amber-300 text-gray-900";
    default:
      return "bg-white border border-gray-200 text-gray-900";
  }
}

export function getReplyQuoteClassName(
  type: MessageReplyTo["type"],
): string {
  switch (type) {
    case "user":
      return "border-emerald-500 bg-emerald-50/80";
    case "assistant":
      return "border-primary bg-primary/5";
    case "operator":
      return "border-sky-400 bg-sky-50/80";
    case "manager-response":
    case "manager":
      return "border-stone-400 bg-stone-100/80";
    default:
      return "border-gray-400 bg-gray-50/80";
  }
}

export function getMessageBubbleHighlightClassName(type: Message["type"]): string {
  switch (type) {
    case "user":
      return "bg-emerald-100 border-emerald-300";
    case "assistant":
    case "operator":
      return "bg-amber-50 border-amber-200";
    case "manager-response":
      return "bg-stone-200 border-stone-400";
    case "manager":
      return "bg-stone-300 border-stone-400";
    case "deferred":
      return "bg-amber-100 border-amber-300";
    default:
      return "bg-amber-50 border-amber-200";
  }
}
